import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

import { FormGroup } from 'components/bootstrap';
import useDataLakeTableOptions from 'data-lake/preview/types/aws-security/hooks/useDataLakeTableOptions';
import useConfiguredDataLakes from 'data-lake/preview/hooks/useConfiguredDataLakes';
import { Select } from 'components/common';

const Container = styled(FormGroup)`
  flex: 1;
  grid-area: table;
`;

const placeholder = 'Select the table you want to preview logs for';

const TableFilter = () => {
  const { selectedDataLake } = useConfiguredDataLakes();
  const { data } = useDataLakeTableOptions(selectedDataLake?.id);

  return (
    <Field name="table">
      {({ field: { name, value, onChange }, meta: { error } }) => (
        <Container data-testid="table-filter" validationState={error ? 'error' : undefined} bsClass="no-bm">
          <Select
            placeholder={placeholder}
            displayKey="key"
            inputId="table-filter"
            value={value}
            options={data}
            multi={false}
            onChange={(newTable: string) => {
              onChange({
                target: { value: newTable, name },
              });
            }}
          />
        </Container>
      )}
    </Field>
  );
};

export default TableFilter;
